import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { SelfSpaceStateService } from '../../services/self-space-state.service';
import { SelfSpaceFacadeService } from '../../services/self-space-facade.service';
import { NotificacionResponse, TipoNotificacion } from '../../models/notificacion.model';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss']
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  pendingCount$!: Observable<number>;
  notificaciones$!: Observable<NotificacionResponse[]>;
  isDropdownOpen = false;
  notificacionesLoaded = false;

  constructor(
    private state: SelfSpaceStateService,
    private facade: SelfSpaceFacadeService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.pendingCount$ = this.state.notificacionesPendientesCount$;
    this.notificaciones$ = this.state.notificaciones$;
  }

  ngOnDestroy(): void {}

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;

    if (this.isDropdownOpen && !this.notificacionesLoaded) {
      this.facade.loadNotificaciones();
      this.notificacionesLoaded = true;
    }
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeDropdown();
  }

  trackById = (_: number, item: { id: number }): number => item.id;

  markAsRead(notificacion: NotificacionResponse): void {
    if (notificacion.leida) return;
    this.facade.markNotificacionAsRead(notificacion.id);
  }

  markAllAsRead(): void {
    this.facade.markAllNotificacionesAsRead();
  }

  getTypeIcon(tipo: TipoNotificacion): string {
    switch (tipo) {
      case 'ANIMO_EQUIPO': return 'mdi-heart';
      case 'RECORDATORIO_REGISTRO': return 'mdi-clock-outline';
      case 'INSIGNIA_GANADA': return 'mdi-trophy';
      case 'BLOQUEO_REPORTADO': return 'mdi-alert';
      default: return 'mdi-bell';
    }
  }

  getTypeClass(tipo: TipoNotificacion): string {
    switch (tipo) {
      case 'ANIMO_EQUIPO': return 'notif-icon--heart';
      case 'RECORDATORIO_REGISTRO': return 'notif-icon--clock';
      case 'INSIGNIA_GANADA': return 'notif-icon--trophy';
      case 'BLOQUEO_REPORTADO': return 'notif-icon--warning';
      default: return '';
    }
  }

  getRelativeTime(fechaCreacion: string): string {
    const now = new Date();
    const date = new Date(fechaCreacion);
    const diffMs = now.getTime() - date.getTime();
    const diffMin = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMin < 1) return 'Ahora';
    if (diffMin < 60) return `Hace ${diffMin} min`;
    if (diffHours < 24) return `Hace ${diffHours}h`;
    if (diffDays === 1) return 'Ayer';
    if (diffDays < 7) return `Hace ${diffDays} dias`;
    const day = date.getDate();
    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    return `${day} ${months[date.getMonth()]}`;
  }
}
